import { ShiftsPlanningVersionFragment } from 'generated/resources/graphql'
import type moment from 'moment'

import { stringToDate } from 'modules/core/lib/dates'

import { PLANNING_TOOL } from 'modules/time_planning/store/models/PlanningVersion'

export interface Props {
  id: number
  effective_at: string
  planning_tool: string
  default: boolean
}

export interface PlanningVersionPayload {
  id: number
  employee_id: number
}

class PlanningVersion {
  id: number
  effectiveAt: moment.Moment
  planningTool: string
  default: boolean

  constructor(props: Props) {
    this.id = props.id
    this.effectiveAt = stringToDate(props.effective_at, 'backend')
    this.planningTool = props.planning_tool
    this.default = props.default
  }

  static buildFromGraphQL(fragment: ShiftsPlanningVersionFragment): PlanningVersion {
    return new PlanningVersion({
      id: fragment.id ?? 0,
      effective_at: fragment.effectiveAt,
      planning_tool: fragment.planningTool,
      default: false,
    })
  }

  get isContractHoursTool(): boolean {
    return this.planningTool === PLANNING_TOOL.contractHours
  }

  get isWorkScheduleTool(): boolean {
    return this.planningTool === PLANNING_TOOL.workSchedule
  }

  get isShiftManagementTool(): boolean {
    return this.planningTool === PLANNING_TOOL.shiftManagement
  }
}

export default PlanningVersion
